import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormField } from '../../../../models/form-field';

@Component({
  selector: 'app-form-row',
  templateUrl: './form-row.component.html',
  styleUrls: ['./form-row.component.scss']
})
export class FormRowComponent implements OnInit {

  @Input() fg: FormGroup;
  @Input() formRow: Array<FormField<any>>;
  rowClasses: string;

  constructor() { }

  ngOnInit() {
    this.rowClasses = (this.formRow.length === 1) ? 'row column form-row form-control-wrapper' : 'row form-row';
  }

}
